// @ts-nocheck
import { LICENSE_ADJUSTMENT_ERROR, LICENSE_ADJUSTMENT_LOADING, LICENSE_ADJUSTMENT_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const license_adjustment = (data, base64File) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: LICENSE_ADJUSTMENT_LOADING,
                data: true
            })
            Authservices.license_adjustment(data, base64File).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: LICENSE_ADJUSTMENT_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: LICENSE_ADJUSTMENT_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}